// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App-module__App--IMqMr{min-height:80vh}a{cursor:pointer}`, "",{"version":3,"sources":["webpack://./src/App.module.scss"],"names":[],"mappings":"AAAA,wBACE,eAAA,CAGF,EACE,cAAA","sourcesContent":[".App {\n  min-height: 80vh;\n}\n\na {\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
export var App = `App-module__App--IMqMr`;
export default ___CSS_LOADER_EXPORT___;
